// src/PublicRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';

const WHOAMI_CACHE_MS = 10000;

function sessionWhoamiFresh() {
  try {
    const ts = Number(sessionStorage.getItem('whoami_ok_ts') || 0);
    return ts && Date.now() - ts < WHOAMI_CACHE_MS;
  } catch {
    return false;
  }
}

export default function PublicRoute({ children }) {
  // If we *very recently* confirmed auth, bounce to the app.
  if (sessionWhoamiFresh()) {
    return <Navigate to="/dashboard/patients" replace />;
  }
  return children;
}
